export enum CellStatus {
  NO_POSITIONS = 'no_positions',
  EMPTY = 'empty',
  UNDERSTAFFED = 'understaffed',
  FULLY_STAFFED = 'fully_staffed',
  OVERSTAFFED = 'overstaffed',
  NOT_APPLICABLE = 'not_applicable',
}
